<template>
  <div class="wrapper">
      <label >{{label}}</label>
      <b-input-group>
         <autocomplete 
                :source="uri"
                :placeholder="place"
                :input-class-required="classeRequired"
                results-display="CODIGONOME"
                results-value="ID"
                :disableInput="desabilitarInput"
                @input="setId"
                @clear="clearComplete({})"
                ref="auto">
          </autocomplete>
          <b-input-group-append>
            <b-btn variant="outline-secondary" :disabled="desabilitarInput" v-b-modal.modalPreventVendedor>{{labelBotao}}
              <i class="fa fa-ellipsis-h"></i></b-btn>
          </b-input-group-append>
      </b-input-group>
    <b-modal id="modalPreventVendedor"
             ref="modalVendedor"
             title="Pesquisar Vendedor"
             class="modal-primary"
             size="lg"
             ok-title="Cancelar"
             ok-only
             @shown="clearModal">
      <b-card>
      <form @submit.stop.prevent="handleSubmit">
        <!-- <b-form-input type="text" placeholder="Enter your name" v-model="resultado"></b-form-input> -->
        <b-row>
          <!--/.col-->
          <b-col sm="8">
                <b-form-input type="text" id="nome" ref="edNomePesquisa" placeholder="Informe o Nome" v-model="pesquisa.nome"> </b-form-input>
          </b-col>
          <b-col sm="4">
            <!-- Button -->
            <b-button  type="submit" variant="outline-secondary" @click.stop.prevent="onSubmit()">
              <span>Pesquisar</span>
            </b-button> 
            <!-- Button -->
            <b-button type="reset"  variant="danger">
                  <i class="fa fa-ban"></i> Limpar
            </b-button>
          </b-col>
        </b-row>
      </form>
      </b-card>
      <b-row  v-if="this.items.length &&  this.items.length > 0">
        <b-col sm="12">
            <!-- Main table element -->
            <b-table class="table table-sm"
                    striped hover 
                    stacked="md"
                    responsive 
                    :busy.sync="isBusy" 
                    :items="items" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @row-clicked="selecionar">
              <template #cell(ID)="item">{{item.item.ID}}</template>
              <template #cell(NOME)="item">{{item.item.NOME}}</template>
            </b-table>
            <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
            </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'

export default {
  props: {
    label: String,
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean,
    desabilitarInput: Boolean 
  },
  data () {
    return {
      resultado: '',
      pesquisa: {
        id: '',
        nome: ''
      },
      isLoading: false,
      status: '',
      isBusy: false,
      items: [],
      fields: [
        {
          key: "ID",
          label: 'Id', 
          class: 'my-left-border my-left-right my-left-bottom',  
          sortable: true 
        },
        {
          key: "NOME",
          label: 'Nome', 
          class: 'my-left-border my-left-right my-left-bottom',  
          sortable: true 
        }
      ],
      currentPage: 1,
      perPage: 5,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.$http.defaults.baseURL.concat('api/protected/vendedorautocomplete?&texto='),
      classeBorda: 'teste'
    }
  },
  components: {
    VueButtonSpinner,
    Autocomplete
  },
  methods: {
    setId (evt) {
      this.$emit('retornaId', evt)
    },
    clearComplete (obj) {
      this.$emit('retornaId', null)
    },
    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
      this.$refs.edNomePesquisa.focus()
    },
    selecionar (evt) {
      this.$emit('retornaId', evt.ID)
      this.$emit('retornaNome', evt.CODIGONOME)
      this.clearModal()
      this.$refs.modalVendedor.hide()
      // Mudar o display do autocomplete..
      this.$refs.auto.display = evt.CODIGONOME
    },
    onSubmit () {
      if ((!this.pesquisa.id) && (!this.pesquisa.nome)) {
        alert('Por Favor! Informe algum texto/valor para pesquisar')
        return
      }
      this.isLoading = true
      this.isBusy = true
      let uri = `/api/protected/vendedorlocalizar?idPesquisa=${this.pesquisa.id}&nomePesquisa=${this.pesquisa.nome}`
      let promise = this.$http.get(uri)
      return promise.then((data) => {
        this.items = data.data
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
        setTimeout(() => {
          this.status = ''
        }, 1000) // to clear the status :)
      }).catch((error) => {
        if (error) {
          this.items = []
          this.isLoading = false
          this.status = false // or error
        }
      })
    },
    atualizaComplete () {
      if (this.idInicial) {
        let uri = `/api/protected/vendedor/pesquisarIdMin/${this.idInicial}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          this.$refs.auto.display = data.data[0].CODIGONOME
          this.$refs.auto.selectedDisplay = data.data[0].CODIGONOME
          this.$refs.auto.value = data.data[0].ID
        })
      }
    },
    atualizaClasse () {
      if (this.classe === '0') {

      }
    }
  },
  watch: {
    // escuta o idInicial para pesquisar o vendedor se o cadastro tiver vendedor_id por exemplo
    'idInicial': function () {
      this.atualizaComplete()
    }
  },
  created () {
    this.atualizaComplete()
  }
}
</script>
<style>
.modal-dialog {
  top: 50px
}
.botao{
  border-radius: 0;
  border: 2px solid #20a8d8;
}
.b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
}
.b-table .my-left-right {
  border-right: 1px solid #a4b7c1;
}
.b-table .my-left-bottom {
  border-bottom: 1px solid #a4b7c1;
}
</style>



// WEBPACK FOOTER //
// src/views/pesquisa/VendedorPesquisa.vue